<div class="container">
  <div>
    <div class="control-buttons">
      <button pButton type="button" class="p-button" [disabled]="creatingAddress" (click)="createNewMailAddress()" data-testing-id="create-new-mail-btn">
        @if (!creatingAddress) {
          <span>Create New Mail Address</span>
        }
        @if (creatingAddress) {
          <span><fa-icon class="loading-spinner" icon="sync-alt" animation="spin"></fa-icon> Create New Mail Address</span>
        }
      </button>
    </div>
    <hr>
  </div>
  @if ((mailsReady || mailAccountsReady) && !loadingData){
    <div class="scrollable">
      <div class="active-heading">Active Mail Accounts</div>
      <div class="active-mails">
        @if (mailAccounts?.length > 0) {
          @for (account of mailAccounts; track account.id) {
            <div class="mail-account">
              <div class="mail-account-info">
                <div class="chevron" (click)="toggleView(account.id)">
                  <fa-icon [icon]="faChevronDown" [ngClass]="{'collapsed': !viewStates[account.id]}"></fa-icon>
                </div>
                <p class="mail-account-header" (click)="copyToClipboard(account.emailAddress)" pTooltip="Copy to Clipboard" [attr.data-testing-id]="account.id + '-mail-address'">{{ account.emailAddress }}</p>
                <div class="mail-account-date">Expires: {{account.expirationDate | date:'d.M.yy'}}</div>
              </div>
              @if (viewStates[account.id]) {
                @if (activeTestRun){
                  <div class="finding">
                    <wm-select-finding type="email" [addAutomaticallyToFinding]="getFindingState(account.emailAddress)" (stateChanged)="updateFindingsState($event, account)" ></wm-select-finding>
                  </div>
                }
                <div class="mails">
                  @if (checkMails(account.id)) {
                    @for (mail of mails; track mail.id) {
                      @if (checkMailId(mail, account.id)) {
                        <wm-mail-overview [mail]="mail"></wm-mail-overview>
                      }
                    }
                  } @else {
                    <div class="info-text">
                      There are no mails for this address.
                    </div>
                  }
                </div>
              }
            </div>
          }
        } @else {
          <div class="info-text">
            No active mail accounts.
          </div>
        }
      </div>
      <hr>
      <div class="prev-heading">Previous Mails</div>
      <div>
        @if (oldMails?.length > 0) {
          <div class="mails">
            @for (mail of oldMails; track mail.id) {
              <wm-mail-overview [mail]="mail"></wm-mail-overview>
            }
          </div>
        } @else {
          <div class="info-text">
            No previous mails.
          </div>
        }
      </div>
    </div>
  } @else if (loadingData) {
      <p-progressSpinner class="progress-spinner"></p-progressSpinner>
  } @else if (!mailsReady && !mailAccountsReady) {
      <p class="message">No mails in this project</p>
  }
  <div class="paginator">
    <hr>
    <p-paginator [first]="firstObject"
                 [rows]="rows"
                 [totalRecords]="totalItems"
                 (onPageChange)="onPageChange($event)"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="{first} - {last} of {totalRecords}"
                 [showPageLinks]="false"
                 [showFirstLastIcon]="true"
                 [showJumpToPageDropdown]="false"
                 styleClass="transparent-bg"
    ></p-paginator>
  </div>
</div>